import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Send, ArrowLeft } from 'lucide-react';
import { helpAPI } from '../api/client';

export default function SupportTicket() {
  const nav = useNavigate();
  const loc = useLocation();
  const [form, setForm] = useState({
    Subject: loc.state?.prefillSubject || '', Body: '', Category: 'Question', Priority: 'Normal',
    PageUrl: loc.state?.from || document.referrer || '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.Subject.trim() || !form.Body.trim()) {
      alert('Subject and description are required'); return;
    }
    setSubmitting(true);
    try {
      const r = await helpAPI.createTicket(form);
      setSuccess(r.data);
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to submit ticket');
    } finally { setSubmitting(false); }
  };

  if (success) {
    return (
      <div className="p-6">
        <div className="bg-emerald-50 border border-emerald-200 rounded-2xl p-8 text-center">
          <div className="text-5xl mb-3">✅</div>
          <h2 className="text-2xl font-bold text-gray-900">Ticket #{success.ticketNumber} created</h2>
          <p className="text-gray-600 mt-2">We'll be in touch by email at {success.email || 'your registered address'}.</p>
          <div className="mt-6 flex gap-3 justify-center">
            <Link to="/help" className="border px-4 py-2 rounded">Back to help</Link>
            <button onClick={() => { setSuccess(null); setForm({ ...form, Subject: '', Body: '' }); }}
              className="bg-blue-600 text-white px-4 py-2 rounded">Submit another</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <Link to="/help" className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-4">
        <ArrowLeft className="w-4 h-4" /> Back to help
      </Link>
      <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
        <h1 className="text-2xl font-bold text-gray-900">Contact support</h1>
        <p className="text-gray-500 text-sm">Tell us what's going on — the more detail the better.</p>

        <form onSubmit={submit} className="mt-5 space-y-4">
          <div>
            <label className="text-xs text-gray-500">Subject</label>
            <input value={form.Subject} onChange={e => setForm(f => ({ ...f, Subject: e.target.value }))}
              className="w-full border rounded px-2 py-1.5 mt-1 text-sm" required />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-xs text-gray-500">Category</label>
              <select value={form.Category} onChange={e => setForm(f => ({ ...f, Category: e.target.value }))}
                className="w-full border rounded px-2 py-1.5 mt-1 text-sm">
                <option>Question</option><option>Bug</option><option>Feature request</option><option>Billing</option>
              </select>
            </div>
            <div>
              <label className="text-xs text-gray-500">Priority</label>
              <select value={form.Priority} onChange={e => setForm(f => ({ ...f, Priority: e.target.value }))}
                className="w-full border rounded px-2 py-1.5 mt-1 text-sm">
                <option>Low</option><option>Normal</option><option>High</option><option>Urgent</option>
              </select>
            </div>
          </div>
          <div>
            <label className="text-xs text-gray-500">Description</label>
            <textarea value={form.Body} onChange={e => setForm(f => ({ ...f, Body: e.target.value }))}
              className="w-full border rounded px-2 py-2 mt-1 text-sm h-40" required />
          </div>
          <div>
            <label className="text-xs text-gray-500">Page URL (optional)</label>
            <input value={form.PageUrl} onChange={e => setForm(f => ({ ...f, PageUrl: e.target.value }))}
              className="w-full border rounded px-2 py-1.5 mt-1 text-sm" />
          </div>
          <div className="flex justify-end">
            <button type="submit" disabled={submitting}
              className="inline-flex items-center gap-2 bg-blue-600 text-white px-5 py-2 rounded hover:bg-blue-700 disabled:opacity-60">
              <Send className="w-4 h-4" /> {submitting ? 'Sending…' : 'Send ticket'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
